var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"test"}},[_c('div',{staticClass:"fb-customerchat",attrs:{"attribution":"install_email","page_id":"103207585241232","theme_color":"#7646ff","logged_in_greeting":"Bienvenido a ElectoralTech, ¿Cómo Podemos Ayudarte?","logged_out_greeting":"Bienvenido a ElectoralTech, ¿Cómo Podemos Ayudarte?"}})])
}]

export { render, staticRenderFns }